{
  "de": {
    "todo": {
      "actions": {
        "add": "Aufgabe hinzufügen",
        "cancel": "Abbrechen",
        "delete_todo": "Aufgabe löschen",
        "edit": "Aufgabe bearbeiten",
        "save": "Speichern"
      },
      "attributes": {
        "active": "Aktiv",
        "assignee": "Verantwortlich",
        "completed": "Erledigt",
        "description": "Beschreibung",
        "due_date": "Frist",
        "title": "Titel"
      },
      "labels": {
        "active": "aktiv",
        "allDone": "Alle Aufgaben sind erledigt!",
        "allTodos": "Alle Aufgaben",
        "completed": "erledigt",
        "filterTodos": "Aufgaben filtern",
        "filters": "Filter",
        "myTodos": "Meine Aufgaben (alt)",
        "myTodosCount": "Meine Aufgaben ({count})",
        "noActiveTodos": "Keine aktiven Aufgaben",
        "noActiveTodosDashboard": "Herzlichen Glückwunsch, Sie haben keine offenen Aufgaben!",
        "noCompletedYet": "Noch keine erledigten Aufgaben.",
        "noTodosCustomer": "Super! Sie haben keine offenen Aufgaben.",
        "selectAProjectFirst": "Wählen Sie zuerst ein Projekt aus",
        "showLess": "Weniger anzeigen",
        "showOthers": "Mehr anzeigen | Mehr anzeigen ({count})"
      },
      "toasts": {
        "create": "Aufgabe erstellt",
        "delete": "Aufgabe gelöscht",
        "update": "Aufgabe aktualisiert"
      },
      "validation": {
        "needtitle": "Titel ist erforderlich"
      }
    }
  }
}
